/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedNotListedHeader_item$ref: FragmentReference;
export type PdpSharedNotListedHeader_item = {|
  +isArt: ?boolean,
  +title: ?string,
  +browseUrl: ?string,
  +categoryPathItemCount: ?number,
  +creators: ?$ReadOnlyArray<?{|
    +creator: ?{|
      +name: ?string,
      +displayName: ?string,
      +urlTag: ?string,
      +publishedItemsCount: ?number,
    |}
  |}>,
  +classification: ?{|
    +creationDate: ?string
  |},
  +categorNameLevel3: ?$ReadOnlyArray<?{|
    +name: ?string
  |}>,
  +categorNameLevel2: ?$ReadOnlyArray<?{|
    +name: ?string
  |}>,
  +vertical: ?VerticalType,
  +$refType: PdpSharedNotListedHeader_item$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "PdpSharedNotListedHeader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryPathItemCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemCreator",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creator",
          "storageKey": null,
          "args": null,
          "concreteType": "Creator",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlTag",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "publishedItemsCount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "classification",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemClassification",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "creationDate",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "categorNameLevel3",
      "name": "getCategoriesByLevel",
      "storageKey": "getCategoriesByLevel(level:3)",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 3,
          "type": "Int!"
        }
      ],
      "concreteType": "Category",
      "plural": true,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "categorNameLevel2",
      "name": "getCategoriesByLevel",
      "storageKey": "getCategoriesByLevel(level:2)",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 2,
          "type": "Int!"
        }
      ],
      "concreteType": "Category",
      "plural": true,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '2eb31f4dff928e307d457a934b0b6e59';
module.exports = node;
